import { Component, OnInit } from '@angular/core';
import { GridButton } from 'src/app/core/models/grid-button.model';
import { GridColumn } from 'src/app/core/models/grid-column.model';
import moment from 'moment';
import { GridFilter } from 'src/app/core/models/grid-filter.model';
import { GridSearchFilter } from 'src/app/core/models/grid-search-filter.model';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-batch',
    templateUrl: './batch.component.html',
    styleUrls: ['./batch.component.scss'],
    standalone: false
})
export class BatchComponent implements OnInit {

  buttons: GridButton[] = [
    {label: 'Download', type: 'btn-primary', action: (button, record) => {
      window.open( environment.publicUrl + 'batchfiles/' + record.filename)
    }} as GridButton,
   ]
   columns: GridColumn[] = [
     {active: true, label: '#', field: 'id'} as GridColumn,
     {active: true, label: 'File Name', field: 'filename'} as GridColumn,
     {active: true, label: 'Created By', field: 'user.firstName', value: (v, r) => r.user.firstName + ' ' + r.user.lastName} as GridColumn,
     {active: true, label: 'Created At', field: 'createdAt', value: v => moment(v).format('DD/MM/YYYY HH:mm:ss')} as GridColumn,
    //  {active: true, label: 'Updated At', field: 'updatedAt', value: v => moment(v).format('DD/MM/YYYY HH:mm:ss')} as GridColumn
   ];

   // Org filter handled at API level
   filters: GridFilter[] = [
   ]

   searchFields: any = ['filename','createdAt'];

   searchFilters: GridSearchFilter[] = [
     {
       field: 'filename',
       label: 'File name',
     } as GridSearchFilter,
     {
       field: 'createdAt',
       label: 'Created On',
       type: 'date',
     } as GridSearchFilter,
   ]
  constructor() { }

  ngOnInit(): void {
  }

  // `generate()` is gone with the 2021 Sage exporter, along with the Batch Date control that fed
  // it. It posted a date to batch/export/date, which built a Sage file and wrote a `batch` row that
  // never recorded which invoices were in the file - so nothing could say what had been sent, and a
  // re-run posted the same invoices again to a Sage that does not deduplicate. Sage export is now
  // /invoices/sage-export.
  //
  // The grid stays, and so do the files it links to: they are the only surviving record of what the
  // old exporter sent.
}
